import ChangingNamePainel from '../ChangingNameBusiness/components/ChangingNamePainel.vue'
import ChangingNameTable from '../ChangingNameBusiness/components/ChangingNameTable.vue'
import AccountMixin from '@/store/module/account/mixin'
import CompanyMixin from '@/store/module/company/mixin'

export default {
  components: {ChangingNamePainel, ChangingNameTable},
  props: ['dataDetails'],
  mixins: [AccountMixin, CompanyMixin],
  name: 'sorting',
  data () {
    return {
      dataSearch: {}
    }
  },
  mounted () {
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/ChangingNameBusiness/ChangingNameBusiness.js